import { Grid } from "@mui/material";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useWebStoreContext } from "contexts";
import { useAppDispatch, useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { onClosePopUp } from "redux/slices";
import { Body, Button, Container, Header, Text, Title } from "./styles";

interface CGGClubHopperProps {}

export const CGGClubHopper = ({}: CGGClubHopperProps) => {
	const dispatch = useAppDispatch();
	const scale = useCalculateScale(363, 428);
	const { getImage } = useImagePath("cdn");
	const headImageUrl = getImage(
		clubGiftsGaloreAssets.v2.popups.shared.background
	);
	const titleUrl = getImage(clubGiftsGaloreAssets.v2.popups.shared.title);
	const { syncUserTracker } = useWebStoreContext();

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	return (
		<Container scale={scale}>
			<Header data-image={headImageUrl}>
				<img src={titleUrl} alt="Club gifts galore" />
			</Header>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>Welcome to your new Club!</Title>
				<Text>
					Your contributions can help this Club
					<br /> reach new Club Gifts Galore heights!
				</Text>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						//sm={isMobile ? 6 : 12}
						display="flex"
						justifyContent="center"
					>
						<Button
							variant="contained"
							themeColor="secondary"
							sx={{
								minWidth: { xs: "80%" /* sm: isMobile ? "100%" : "80%" */ }
							}}
							onClick={() => {
								syncUserTracker();
								dispatch(onClosePopUp());
							}}
						>
							Continue Shopping
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="daily_reward_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
